/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardStatsDto } from '../../models/dashboard-stats-dto';

export interface VolunteerStatsControllerGetUserStats$Params {
  userId: string;
}

export function volunteerStatsControllerGetUserStats(http: HttpClient, rootUrl: string, params: VolunteerStatsControllerGetUserStats$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardStatsDto>> {
  const rb = new RequestBuilder(rootUrl, volunteerStatsControllerGetUserStats.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DashboardStatsDto>;
    })
  );
}

volunteerStatsControllerGetUserStats.PATH = '/volunteer-stats/user/{userId}';
